import React, { useContext, useEffect, useState } from "react";
import { ReactSVG } from "react-svg";

import downloadIcon from "../../../assets/svg/download.svg";
import { EXAM_DOCUMENTS_ENABLED } from "../../../constants/examDocuments";
import { StudentInfoContext } from "./StudentInfoContext";
import { fetchStudentPracticalExams } from "./studentPracticalExams";

export default function StudentPracticalExamsTab() {
   const {
      studentId,
      handleDownloadBorderou,
      downloadingDocumentId,
      downloadError,
   } = useContext(StudentInfoContext);
   const [exams, setExams] = useState([]);
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState("");

   useEffect(() => {
      let stop = false;
      if (!studentId) {
         setExams([]);
         return undefined;
      }

      (async () => {
         setLoading(true);
         setError("");
         try {
            const rows = await fetchStudentPracticalExams(studentId);
            if (!stop) setExams(rows);
         } catch (e) {
            if (!stop) {
               setExams([]);
               setError(e?.message || "Nu am putut încărca examenele practice.");
            }
         } finally {
            if (!stop) setLoading(false);
         }
      })();

      return () => {
         stop = true;
      };
   }, [studentId]);

   const renderDocButton = ({ label, title, busy, disabled, onClick }) => (
      <button
         type="button"
         className={
            "studentsProfileUI__practicalDoc studentsProfileUI__practicalDoc--labeled" +
            (busy ? " is-busy" : "")
         }
         title={busy ? "Se descarcă…" : title}
         aria-label={title}
         disabled={disabled}
         onClick={onClick}
      >
         <ReactSVG
            src={downloadIcon}
            className={
               "studentsProfileUI__practicalDocIcon" + (busy ? " is-loading" : "")
            }
         />
         <span className="studentsProfileUI__practicalDocLabel">{label}</span>
      </button>
   );

   return (
      <div className="studentsProfileUI__attempts">
         {loading && <p>Se încarcă examenele practice…</p>}
         {error && <p className="students-info__error">{error}</p>}
         {downloadError && (
            <p className="students-info__error">Descărcare: {downloadError}</p>
         )}

         {!loading && !error && exams.length === 0 && (
            <p className="students-info__empty">Nu există examene practice.</p>
         )}

         {!loading && !error && exams.length > 0 && (
            <div className="studentsProfileUI__practicalList">
               {exams.map((exam) => {
                  const meta = [exam.sector, exam.gearbox, exam.instructorName]
                     .filter(Boolean)
                     .join(" · ");
                  const anyBusy = Boolean(downloadingDocumentId);
                  const busy = Boolean(exam.id) && downloadingDocumentId === exam.id;

                  return (
                     <article
                        key={exam.key}
                        className={
                           "studentsProfileUI__practical studentsProfileUI__practical--" +
                           String(exam.status || "scheduled").toLowerCase()
                        }
                     >
                        <div className="studentsProfileUI__practicalMain">
                           <p className="studentsProfileUI__practicalDate">
                              {exam.dateLabel}
                              {", "}
                              <span className="studentsProfileUI__practicalTime">
                                 {exam.timeLabel}
                              </span>
                           </p>
                           <p className="studentsProfileUI__practicalExtra">
                              {meta || "—"}
                           </p>
                        </div>

                        <div className="studentsProfileUI__practicalSide">
                           <span className="studentsProfileUI__practicalStatus">
                              {exam.statusLabel}
                           </span>

                           {EXAM_DOCUMENTS_ENABLED && exam.id
                              ? renderDocButton({
                                   label: "Borderou",
                                   title: "Descarcă borderoul acestui examen practic",
                                   busy,
                                   disabled: anyBusy,
                                   onClick: () => handleDownloadBorderou?.(exam.id),
                                })
                              : null}
                        </div>
                     </article>
                  );
               })}
            </div>
         )}
      </div>
   );
}
